<div [formGroup]="parentGroup" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openIconSelectDialog()" class="form-element">
    <span class="title">{{ formElement.text }}</span> <span class="asterisk" *ngIf="formElement.requiredField">*</span>

    <div class="icon-row">
        <div *ngIf="isValueSelected(); else noIcon">
            <mat-icon class="material-icons-outlined" matTooltip="Select Icon">{{ icon }}</mat-icon>
        </div>
        <ng-template #noIcon>
            <div class="no-image" matTooltip="Select Icon"></div>
        </ng-template>
        
        <span matSuffix 
            *ngIf="this.formElement.disabled !== 'true' && isValueSelected()"
            matTooltip="Clear"
            class="clear-icon"
            style="margin-right: 8px;">
            <mat-icon 
            setColor 
            [setColorRules]="[
                {
                    color: 'primaryColour',
                    events: ['hover']
                }
            ]"
            class="material-icons-outlined clickable-icon" 
            appPreventDoubleClick (throttledClick)="$event.stopPropagation(); clearValue()">close</mat-icon>
        </span>
    </div>


    <mat-form-field appearance="fill" hidden>
        <mat-label>
            {{ formElement.text }}
            <span class="asterisk" *ngIf="formElement.requiredField">*</span>
        </mat-label>

        <input matInput [formControlName]="formElement.formControl">
    </mat-form-field>
</div>
